import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { ModelActionsModal } from '@models-global/model-actions';
import * as actions from '@module-claims/store/prescriber.actions';
import { PrescriberCEAssociationAddParams } from '@module-claims/models/prescriber.interface';

export interface ICEAssociationRemovalModalState {
  readonly action?: ModelActionsModal;
  readonly data?: PrescriberCEAssociationAddParams;
}

@State<ICEAssociationRemovalModalState>({
  name: 'CEAssociationRemovalModalState',
  defaults: {
    action: undefined,
    data: undefined
  }
})
@Injectable()
export class CEAssociationRemovalModalState {
  @Action(actions.PrescriberCEAssociationRemovalModalSave)
  saveModal(
    ctx: StateContext<ICEAssociationRemovalModalState>,
    { params }: actions.PrescriberCEAssociationModalSave
  ): void {
    ctx.patchState({
      action: 'save',
      data: params
    });
  }

  @Action(actions.PrescriberCEAssociationRemovalModalClose)
  closeModal(ctx: StateContext<ICEAssociationRemovalModalState>): void {
    ctx.patchState({
      action: 'close',
      data: undefined
    });
  }
}
